<button
  class="usersDropdownButton"
  [class.usersDropdownButton--add]="!ppSelected()"
  [class.usersDropdownButton--remove]="ppSelected()"
  (click)="ppSelect.emit()"
>
  {{ (ppSelected() ? 'remove' : 'add') | ppTranslate }}
</button>
